import { http } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function getSuperapiOnboardingSession(
  superStepOnboardingSessionId
) {
  try {
    const { data } = await http.get(
      `/superstep/onboarding-sessions/${superStepOnboardingSessionId}`
    );

    return data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to get superapi onboarding session',
      source: 'get-superapi-onboarding-session',
      metadata: {
        superStepOnboardingSessionId,
      },
      error: e,
    });
    throw e;
  }
}
